import type {SvgIconData} from '@repo/shared-web/components/core/svg_icon';

export const downloadIcon: SvgIconData = {
  viewBox: '3.5 3 9 9.5',
  element: (
    <g>
      <path d="M8.5 8.3V3.5a.5.5 0 0 0-1 0v4.8L5.9 6.6a.5.5 0 1 0-.8.8L8 10.2l2.9-2.8a.5.5 0 0 0-.8-.8L8.5 8.3Z" />
      <path d="M4 9.5c.3 0 .5.2.5.5v.8c0 .4.3.7.7.7h5.6c.4 0 .7-.3.7-.7V10a.5.5 0 0 1 1 0v.8c0 1-.8 1.7-1.7 1.7H5.2c-1 0-1.7-.8-1.7-1.7V10c0-.3.2-.5.5-.5Z" />
    </g>
  ),
};
